import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  ViewEncapsulation,
} from '@angular/core';

import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FaIconComponent } from '@akostm/orbit-ui';
import { faRectangleXmark, faUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { HeaderButtonType } from '../../../interfaces';

@Component({
  selector: 'shared-header-list-item',
  standalone: true,
  imports: [FaIconComponent],
  templateUrl: './header-list-item.component.html',
  styleUrl: './header-list-item.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderListItemComponent {
  icon = input.required<IconProp>();
  text = input.required<string>();
  event = input.required<HeaderButtonType>();
  buttonClick = output<HeaderButtonType>();

  xRectangleIcon: IconProp = faRectangleXmark;
  squareArrowIcon: IconProp = faUpRightFromSquare;
}
